module.exports = __webpack_public_path__ + "static/images/logo-dark.4cbd62e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Themes/Asurion/logo-dark.jpg
// module id = QeL4
// module chunks = 12